import { TodoDto } from '../../data-transfer-objects';

/**
 * Event Types
 */
export enum TodoEventTypes {
  TODO_CREATED = '[Todos] Todo Created',
  TODO_UPDATED = '[Todos] Todo Updated',
  TODO_DELETED = '[Todos] Todo Deleted',
}

/**
 * Payloads
 */
export interface TodoEventPayload {
  todo: TodoDto;
}

export interface TodoDeletedEventPayload {
  todoId: number;
  userId: string;
}

/**
 * Events
 */
export class TodoCreatedEvent {
  readonly type = TodoEventTypes.TODO_CREATED;

  constructor(public payload: TodoEventPayload) {}
}

export class TodoUpdatedEvent {
  readonly type = TodoEventTypes.TODO_UPDATED;

  constructor(public payload: TodoEventPayload) {}
}

export class TodoDeletedEvent {
  readonly type = TodoEventTypes.TODO_DELETED;

  constructor(public payload: TodoDeletedEventPayload) {}
}
